module.exports = __webpack_public_path__ + "img/rule60.png";